<div class="form-group">
  <ng-select
    [items]="filteredValues"
    bindValue="key"
    bindLabel="value"
    placeholder="{{getPlaceholder()}}"
    [(ngModel)]="attribute.value"
    (change)="onSelectChange($event)"
    (search)="onSearch($event)">
  </ng-select>
</div>